import React, { Component } from 'react'

const DefaultLoadingLogo = ({ width = '200px', height = '200px' }) => {
  return (
    <svg className='animate__animated animate__shakeY animate__slow animate__infinite' viewBox='0 0 1200 1200' width={width} height={height} xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
      <defs>
        <path id='logo' d='m0 82.5 h 817.5 v 245 h -735 v 245 h 735 v 245 h -817.5' fill='none' strokeWidth='165' />
        <g id='animated-logo' stroke='#FFCD00'>
          <use href='#logo' strokeDasharray='4280, 1400' />
          {/* <animate attributeName='stroke-dashoffset' from='5680' to='0' dur='1s' repeatCount='indefinite' /> */}
        </g>
      </defs>
      <use href='#animated-logo' x='150' y='150' />
    </svg>
  )
}

const CustomLoadingLogo = ({ width = '200px', height = '200px', loader, useSvgCustomLoader }) => {
  return (
    <>
      {
        useSvgCustomLoader
          ? <div dangerouslySetInnerHTML={{ __html: loader }} />
          : <img width={width} height={height} src={loader} alt={'loading..'} className={'loading-image'} />
      }
    </>
  )
}

class Loading extends Component {
  render () {
    const { width, height, store } = this.props
    const { customLoader, customSvgLoader, useCustomLoader, useSvgCustomLoader } = store?.settings || {}
    return (
      <>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
          {
            useCustomLoader
              ? <CustomLoadingLogo
                width={width}
                height={height}
                useSvgCustomLoader={useSvgCustomLoader}
                loader={useSvgCustomLoader ? customSvgLoader : customLoader}
              />
              : <DefaultLoadingLogo width={width} height={height} />
          }
        </div>
      </>
    )
  }
}

const LoadingLogo = Loading

export { Loading }
export default LoadingLogo
